import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "titlePages" }
const _hoisted_2 = { class: "mapa-wrapper" }
const _hoisted_3 = { class: "controles-custom-top-left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { id: "map" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "Búsqueda Equipo", -1)
const _hoisted_6 = { class: "mb-2 mt-4" }

import { watch, ref, Ref, onMounted, computed } from "vue";

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from "vuetify";
import { useI18n } from "vue-i18n";
import maplibregl, { LngLatLike } from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS, STRING_GENERAL } from "@/constants/labels";
import { COLOR } from "@/constants/colors";
import CONSTMAPS from "@/constants/maps";

/********************************
 ********** INTERFACES **********
 *******************************/
import {
  DRIVE_OBS,
  DRIVE_PROPS,
  PARAMETROS,
} from "@/interfaces/SmartLink/Equipos";
import { TOPO_ITEMS } from "@/interfaces/SmartLink/Topology";
import { STRINGS } from "@/interfaces/SmartLink/General";

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from "vuex";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

import {
  getAllClientDevice,
  getAllLatencyDriveByIP,
  getAllLocationDriveByIP,
  getRajantGPS,
} from "@/services/Smartlink/Drive";
import { getRajantLastGPS } from "@/services/Smartlink/Map";

import miIconoPersonalizado from "@/assets/Icons/solartrailer3.jpg";
import miIconoCamion from '@/assets/Icons/camion.jpg'


export default /*#__PURE__*/_defineComponent({
  __name: 'DriveHeatmapView',
  setup(__props) {

const { mdAndDown } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 *********** MAPLIBRE ***********
 *******************************/
const store = useStore();
const projectName = computed(() => store.state.projectName);


const dateini = ref(projectName.value === "SmartLinkDEMO" ? '2026-04-30 12:00:00' : '')
const datefin = ref(new Date())
const dateMAX = ref(projectName.value === "SmartLinkDEMO" ? '2026-04-30 12:00:00' : new Date())

/**
 * Titulo de la vista
 */
const title = computed(() => "Heatmap Drive");

/**
 * Ancho del mapa
 */
const width = ref("350");

watch(mdAndDown, (valor: boolean) => {
  valor ? (width.value = "100%") : (width.value = "350");
});

/**
 * Deshabilita el boton mientras se realiza la peticion
 */
const disabledAXIOS = ref(false);

/**
 * checkbox del ETH0
 */
const selectedETH0: Ref<boolean> = ref(true);

/**
 * checkbox del RPTPEER
 */
const selectedRPTPEER: Ref<boolean> = ref(false);

/**
 * checkbox del WLAN0
 */
const selectedWLAN0: Ref<boolean> = ref(false);

/**
 * checkbox del WLAN1
 */
const selectedWLAN1: Ref<boolean> = ref(false);

/**
 * checkbox del WLAN2
 */
const selectedWLAN2: Ref<boolean> = ref(false);

/**
 * checkbox del WLAN3
 */
const selectedWLAN3: Ref<boolean> = ref(false);

/**
 * checkbox del LATENCIA
 */
const selectedLATENCIA: Ref<boolean> = ref(true);

/**
 * Muestra error si no hay datos
 */
const showError = ref(false);

/**
 * Muestra los checkbox
 */
const showCheckBoxes = ref(false);

const COLORRED = COLOR.red;
const COLORYELLOW = COLOR.yellow;
const COLORGREEN = COLOR.green;
const COLORGREY = COLOR.grey;

/**
 * Obtiene el color dependiendo del valor
 * @param value
 * @param limit
 * @param colors
 */
const getColorByValue = (value: number, limit: number[], colors: string[]) => {
  if (value === 0) return COLORGREY;
  let finalColor = colors;
  let selectedColor = COLORGREY;
  limit.forEach((limited, i) => {
    if (value > limited) selectedColor = finalColor[i];
  });
  return selectedColor;
};

/**
 * Array Final de los datos ETH0
 */
const finalETH0Array = ref<DRIVE_PROPS[]>([]);

/**
 * Objeto Final de los datos ETH0
 */
const finalETH0Object = ref<DRIVE_OBS>({ features: [], type: "" });

/**
 * Array Final de los datos RPTPEER
 */
const finalRPTPEERArray = ref<DRIVE_PROPS[]>([]);

/**
 * Objeto Final de los datos RPTPEER
 */
const finalRPTPEERObject = ref<DRIVE_OBS>({ features: [], type: "" });

/**
 * Array Final de los datos WLAN0
 */
const finalWLAN0Array = ref<DRIVE_PROPS[]>([]);

/**
 * Objeto Final de los datos WLAN0
 */
const finalWLAN0Object = ref<DRIVE_OBS>({ features: [], type: "" });

/**
 * Array Final de los datos WLAN1
 */
const finalWLAN1Array = ref<DRIVE_PROPS[]>([]);

/**
 * Objeto Final de los datos WLAN1
 */
const finalWLAN1Object = ref<DRIVE_OBS>({ features: [], type: "" });

/**
 * Array Final de los datos WLAN2
 */
const finalWLAN2Array = ref<DRIVE_PROPS[]>([]);

/**
 * Objeto Final de los datos WLAN2
 */
const finalWLAN2Object = ref<DRIVE_OBS>({ features: [], type: "" });

/**
 * Array Final de los datos WLAN3
 */
const finalWLAN3Array = ref<DRIVE_PROPS[]>([]);

/**
 * Objeto Final de los datos WLAN3
 */
const finalWLAN3Object = ref<DRIVE_OBS>({ features: [], type: "" });

/**
 * Array Final de los datos LATENCIA
 */
const finalLATENCIAArray = ref<DRIVE_PROPS[]>([]);

/**
 * Objeto Final de los datos LATENCIA
 */
const finalLATENCIAObject = ref<DRIVE_OBS>({ features: [], type: "" });

function getFinalPositions(lat: number, lng: number) {
  let lat1 = lat + 0.0002;
  let lng1 = lng + 0.0002;
  let finalItem = [
    [lng, lat],
    [lng1, lat],
    [lng1, lat1],
    [lng, lat1],
    [lng, lat],
  ];
  return finalItem;
}

const filters = ref({
  LATENCIA: [
    { label: 'OK', color: 'green', value: 'ok', active: true },
    { label: 'Alerta', color: 'yellow', value: 'alert', active: true },
    { label: 'Alarma', color: 'red', value: 'alarm', active: true },
    { label: 'Caido', color: 'grey', value: 'down', active: true },
  ],
});

const onFilterChange = async () => {
  // Extraemos solo los "values" que están activos (ej: ['ok', 'alert'])
  const activeStatus = filters.value.LATENCIA
    .filter(f => f.active)
    .map(f => f.value);

console.log("Active Status:", activeStatus);
console.log("Original LATENCIA Array:", finalLATENCIAArray.value);

  // Filtramos el array original
  const filteredFeatures = finalLATENCIAArray.value.filter(item => 
    activeStatus.includes(item.properties.status)
  );

  // Actualizamos el mapa
  finalLATENCIAObject.value = {
    type: "FeatureCollection",
    features: filteredFeatures,
  };

  await setSourceAndLayer(
    "SourceLATENCIA",
    finalLATENCIAObject.value,
    "LayerLATENCIA"
  );
};

function getStatusByValue(val: number): string {
  if (val < 0) return 'down';
  if (val <= 100) return 'ok';
  if (val <= 200) return 'alert';
  return 'alarm';
}


/**
 * Lista final de camiones
 */
const finalListTruck: Ref<TOPO_ITEMS[]> = ref([]);

/**
 * ?Lista computada de camiones?
 */
const computedListTruck = computed(() => finalListTruck.value);

/**
 * Obtiene todos los camiones de la API
 */
const getAllHaulTrucks = async () => {
  const allData = await getAllClientDevice();

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    finalListTruck.value = allData.data;
  }
};

async function allClearData() {
  clearLayerSource("LayerETH0", "SourceETH0");
  clearLayerSource("LayerRPTPEER", "SourceRPTPEER");
  clearLayerSource("LayerWLAN0", "SourceWLAN0");
  clearLayerSource("LayerWLAN1", "SourceWLAN1");
  clearLayerSource("LayerWLAN2", "SourceWLAN2");
  clearLayerSource("LayerWLAN3", "SourceWLAN3");
  clearLayerSource("LayerLATENCIA", "SourceLATENCIA");

  selectedETH0.value = true;
  selectedRPTPEER.value = false;
  selectedWLAN0.value = false;
  selectedWLAN1.value = false;
  selectedWLAN2.value = false;
  selectedWLAN3.value = false;
  selectedLATENCIA.value = true;
  showError.value = false;
  showCheckBoxes.value = false;
  finalETH0Array.value = [];
  finalRPTPEERArray.value = [];
  finalWLAN0Array.value = [];
  finalWLAN1Array.value = [];
  finalWLAN2Array.value = [];
  finalWLAN3Array.value = [];
  finalLATENCIAArray.value = [];
}

const finalLatency = ref([]);
const finalLocation = ref([]);

async function getLocationDriveByIP(params: PARAMETROS) {
  const allData = await getAllLocationDriveByIP(params);

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    finalLocation.value = allData.data;
  }
}

async function getLatencyDriveByIP(params: PARAMETROS) {
  const allData = await getAllLatencyDriveByIP(params);

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    finalLatency.value = allData.data;
  }
}

async function getAllInfoMatch() {
  const finalItems = ref<any[]>([]);
  finalLatency.value.forEach((item: any) => {
    finalLocation.value.find(({ fecha, latitud, longitud }: any) => {
      if (item.fecha === fecha) {
        let finalITEM = {
            ip: item.ip,
            name: item.name,
            fecha: item.fecha,
            latitud: latitud,
            longitud: longitud,
            latencia: item.latencia,
        };
        finalItems.value.push(finalITEM);
      }
    });
  });

  return finalItems.value;
}

/**
 * Equipo Seleccionado en el HTML
 */
const haulTrucksSelected = ref([]);

/**
 * Obtiene la información del equipo seleccionado
 */
async function getHaulTruckPositions() {
  allClearData();

  let params = {
    ip: haulTrucksSelected.value,
    dateini: dateini.value,
    datefin: datefin.value,
  };

  await getLocationDriveByIP(params);
  await getLatencyDriveByIP(params);

  const finalItem = await getAllInfoMatch();

  if (finalItem.length > 0) {
    let index = 0;
    finalItem.forEach((item: any) => {
      index = index + 1;

      let latencia =
        item.latencia !== "" && item.latencia ? parseFloat(item.latencia) : 0;
      let colorlatencia = getColorByValue(
        latencia,
        [0, 100, 200],
        [COLORGREEN, COLORYELLOW, COLORRED],
      );
      let finalINFOLatencia = latencia
        ? `IP: ${item.ip} <br/> Nombre: ${item.name} <br/> LATENCIA: ${latencia}ms <br/> Fecha: ${item.fecha}`
        : "";

      latencia
        ? postPORTItems(
            "LATENCIA",
            item.latitud,
            item.longitud,
            colorlatencia,
            finalINFOLatencia,
            index,
            item.fecha,
            latencia
          )
        : null;
    });

    if (finalLATENCIAArray.value.length > 0) {
      finalLATENCIAObject.value = {
        features: finalLATENCIAArray.value,
        type: "FeatureCollection",
      };
      await setSourceAndLayer(
        "SourceLATENCIA",
        finalLATENCIAObject.value,
        "LayerLATENCIA",
      );
    }
    showCheckBoxes.value = true;
    showError.value = false;
  } else {
    showError.value = true;
    showCheckBoxes.value = false;
  }
}


/**
 * Agrega los items al array correspondiente con formato geojson
 * @param tipo
 * @param latitud
 * @param longitud
 * @param color
 * @param valor
 * @param index
 * @param fecha
 */
function postPORTItems(
  tipo: string,
  latitud: number,
  longitud: number,
  color: string,
  valor: string,
  index: number,
  fecha: string,
  valorFinal: number
) {

    const status = getStatusByValue(valorFinal);

    let finalITEM = {
        type: "Feature",
        properties: {
            level: 0,
            name: `AllGraph${tipo}`,
            height: 40,
            base_height: 0,
            color: color,
            center: [longitud, latitud],
            valor: valor,
            fecha: fecha,
            status: status,
            tipo: tipo.toUpperCase(),
        },
        geometry: {
            coordinates: [getFinalPositions(latitud, longitud)],
            type: "Polygon",
        },
        id: index,
    };

    // const targetArray = getArrayByTipo(tipo); 
    // targetArray.value.push(finalITEM);
    if (tipo.toUpperCase() === "ETH0") {
        finalETH0Array.value.push(finalITEM);
    }
    if (tipo.toUpperCase() === "RPTPEER") {
        finalRPTPEERArray.value.push(finalITEM);
    }
    if (tipo.toUpperCase() === "WLAN0") {
        finalWLAN0Array.value.push(finalITEM);
    }
    if (tipo.toUpperCase() === "WLAN1") {
        finalWLAN1Array.value.push(finalITEM);
    }
    if (tipo.toUpperCase() === "WLAN2") {
        finalWLAN2Array.value.push(finalITEM);
    }
    if (tipo.toUpperCase() === "WLAN3") {
        finalWLAN3Array.value.push(finalITEM);
    }
    if (tipo.toUpperCase() === "LATENCIA") {
        finalLATENCIAArray.value.push(finalITEM);
    }
    
}

/**
 * Agrega el Layer y el Source al mapa
 * @param source
 * @param alldata
 * @param layer
 */
async function setSourceAndLayer(
  source: string,
  alldata: DRIVE_OBS,
  layer: string,
) {
  const mySource = map.getSource(source);
  if (mySource === undefined) {
    map.addSource(source, { type: "geojson", data: alldata });
    map.addLayer({
      id: layer,
      type: "fill-extrusion",
      source: source,
      paint: {
        "fill-extrusion-color": ["get", "color"],
        "fill-extrusion-height": ["get", "height"],
        "fill-extrusion-base": ["get", "base_height"],
        "fill-extrusion-opacity": 1,
      },
    });

    const popup = new maplibregl.Popup({
      closeButton: false,
      closeOnClick: false,
    });

    /* eslint-disable */
    map.on("mouseenter", layer, (e: any) => {
      map.getCanvas().style.cursor = "pointer";

      const coordinates: any = [e.lngLat.lng, e.lngLat.lat];
      const valor = e.features[0].properties.valor;
      let mensaje = `${valor}`;

      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }

      popup.setLngLat(coordinates).setHTML(mensaje).addTo(map);
    });

    map.on("mouseleave", layer, () => {
      map.getCanvas().style.cursor = "";
      popup.remove();
    });
  } else {
    mySource.setData(alldata);
  }
}

/**
 * Limpia el layer y el source del mapa
 * @param layer
 * @param source
 */
function clearLayerSource(layer: string, source: string) {
  if (map.getLayer(layer)) {
    map.removeLayer(layer);
  }
  if (map.getSource(source)) {
    map.removeSource(source);
  }
}

/**
 * Observa los checkbox para agregar o quitar layers del mapa
 * @param selectedVar
 * @param type
 * @param source
 * @param finalObject
 * @param layer
 */
function watchLayer(
  selectedVar: Ref<boolean>,
  source: string,
  finalObject: Ref<DRIVE_OBS>,
  layer: string,
) {
  watch(selectedVar, (state) => {
    if (state) {
      setSourceAndLayer(source, finalObject.value, layer);
    } else {
      clearLayerSource(layer, source);
    }
  });
}

watchLayer(selectedETH0, "SourceETH0", finalETH0Object, "LayerETH0");
watchLayer(
  selectedRPTPEER,
  "SourceRPTPEER",
  finalRPTPEERObject,
  "LayerRPTPEER",
);
watchLayer(selectedWLAN0, "SourceWLAN0", finalWLAN0Object, "LayerWLAN0");
watchLayer(selectedWLAN1, "SourceWLAN1", finalWLAN1Object, "LayerWLAN1");
watchLayer(selectedWLAN2, "SourceWLAN2", finalWLAN2Object, "LayerWLAN2");
watchLayer(selectedWLAN3, "SourceWLAN3", finalWLAN3Object, "LayerWLAN3");
watchLayer(
  selectedLATENCIA,
  "SourceLATENCIA",
  finalLATENCIAObject,
  "LayerLATENCIA",
);


// Colores KML: Formato AABBGGRR (Opacidad + Azul + Verde + Rojo)
const KML_COLORS: Record<string, string> = {
  "#E04637": "ff3746e0", // Red
  "#F9DC4B": "ff4bdcf9", // Yellow
  "#427739": "ff397742", // Green
  "#CAC8C8": "ffc8c8ca", // Grey
  "#00A5E8": "ffe8a500", // Blue
};

/**
 * Genera el XML de un polígono 3D para KML
 */
const generarCuboKML = (element: any) => {
  const coords = element.geometry.coordinates[0];
  // Generamos los puntos para la base (suelo) y el techo (20m)
  const base = coords.map((c: any) => `${c[0]},${c[1]},0`).join(' ');
  const techo = coords.map((c: any) => `${c[0]},${c[1]},20`).join(' ');
  
  const styleId = `style-${(element.properties.color || "#CAC8C8").replace('#', '')}`;

  return `
    <Placemark>
      <name>${element.id}</name>
      <description><![CDATA[
        <b>Valor:</b> ${element.properties.valor}<br/>
        <b>Fecha:</b> ${element.properties.fecha}
      ]]></description>
      <styleUrl>#${styleId}</styleUrl>
      <MultiGeometry>
        <Polygon>
          <extrude>1</extrude>
          <altitudeMode>relativeToGround</altitudeMode>
          <outerBoundaryIs><LinearRing><coordinates>${base}</coordinates></LinearRing></outerBoundaryIs>
        </Polygon>
        <Polygon>
          <extrude>1</extrude>
          <altitudeMode>relativeToGround</altitudeMode>
          <outerBoundaryIs><LinearRing><coordinates>${techo}</coordinates></LinearRing></outerBoundaryIs>
        </Polygon>
      </MultiGeometry>
    </Placemark>`;
};

/**
 * Función Principal para generar el KMZ
 */
async function generarKMZ() {
 const zip = new JSZip();
  const iconoDefault = "https://maps.google.com/mapfiles/kml/paddle/blu-circle.png";

  // --- 1. DEFINICIÓN DE ESTILOS ---
  const stylesXml = Object.entries(KML_COLORS).map(([hex, kml]) => `
    <Style id="style-${hex.replace('#', '')}">
      <LineStyle><color>${kml}</color><width>1</width></LineStyle>
      <PolyStyle><color>${kml}</color><fill>1</fill></PolyStyle>
    </Style>`).join('');

  // --- 2. LÓGICA DE INTERFACES (ESCALABLE) ---
  // Por ahora solo usamos LATENCIA, pero puedes agregar más aquí en el futuro
  const interfacesActivas = [
    { nombre: "LATENCIA", data: finalLATENCIAObject.value }
    // { nombre: "ETH0", data: finalETH0Object.value }, <-- Ejemplo de cómo escalar
  ];

  const foldersInterfaces = interfacesActivas
    .filter(i => i.data?.features?.length > 0)
    .map(i => `
      <Folder>
        <name>📊 INTERFAZ: ${i.nombre}</name>
        ${i.data.features.map(generarCuboKML).join('')}
      </Folder>`).join('');

  // --- 3. JERARQUÍA DE EQUIPOS (Nivel 1 > Nivel 2 > Nivel 3) ---
  const jerarquiaXml = jerarquiaEquipos.value.map(grupo => `
    <Folder>
      <name>📁 CATEGORÍA: ${grupo.nombre}</name>
      ${grupo.subgrupos.map(sub => `
        <Folder>
          <name>📦 TIPO: ${sub.nombre}</name>
          ${sub.equipos.filter(e => e.visible).map(e => `
            <Placemark>
              <name>${e.name}</name>
              <styleUrl>#customMarkerStyle</styleUrl>
              <Point><coordinates>${e.longitud},${e.latitud},0</coordinates></Point>
            </Placemark>`).join('')}
        </Folder>`).join('')}
    </Folder>`).join('');

  // --- 4. ENSAMBLAJE FINAL DEL KML ---
  const kmlFinal = `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
  <Document>
    <name>Resumen Operaciones Rajant</name>
    ${stylesXml}
    <Style id="customMarkerStyle">
      <IconStyle><scale>1.2</scale><Icon><href>files/icon.png</href></Icon></IconStyle>
    </Style>
    ${jerarquiaXml}
    ${foldersInterfaces}
  </Document>
</kml>`;

  // --- 5. EMPAQUETADO ---
  zip.file("doc.kml", kmlFinal);
  
  // Incluimos el icono en el archivo para que sea portable
  try {
    const iconBlob = await fetch(iconoDefault).then(r => r.blob());
    zip.file("files/icon.png", iconBlob);
  } catch (e) {
    console.warn("No se pudo adjuntar el icono al KMZ, se usará marcador genérico.");
  }

  // Descarga
  const content = await zip.generateAsync({ type: "blob" });
  saveAs(content, `KMZ_Organizado_${new Date().getTime()}.kmz`);
}

const allMarkerData = ref<any>([]);

async function getAllRajantPositions() {
  const allData = await getRajantLastGPS();

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    allMarkerData.value = allData.data;
    // agregarMarcadores(map, allData.data);
  }
}

// 1. La lista para dibujar los checkboxes en tu <template> con v-for
const listaEquipos = ref<any[]>([]);

// ==========================================
// 1. FUNCIÓN CENTRAL QUE ACTUALIZA EL MAPA
// ==========================================
const actualizarMapaGeoJSON = () => {
  // Diagnóstico 1: ¿Existe la instancia del mapa y la fuente?
  if (!map) {
    console.error("🛑 DEBUG: La variable 'map' es null o undefined.");
    return;
  }
  if (!map.getSource("equipos-source")) {
    console.warn(
      "⚠️ DEBUG: La fuente 'equipos-source' aún no existe en el mapa.",
    );
    return;
  }

  const equiposVisibles = listaEquipos.value.filter((e) => e.visible);

  const features = equiposVisibles.map((equipo) => {
    // Diagnóstico 3: Validar coordenadas
    if (equipo.longitud === undefined || equipo.latitud === undefined) {
      console.error(
        `🛑 DEBUG: Equipo ${equipo.name} no tiene coordenadas válidas.`,
        equipo,
      );
    }

    return {
      type: "Feature",
      geometry: {
        type: "Point",
        // RECUERDA: [Longitud, Latitud]
        coordinates: [Number(equipo.longitud), Number(equipo.latitud)],
      },
      properties: {
        name: equipo.name,
        subtipo: equipo.subtipo
      },
    };
  });

  map.getSource("equipos-source").setData({
    type: "FeatureCollection",
    features: features,
  });
};

// ==========================================
// 2. HELPERS SIMPLIFICADOS
// ==========================================
const alternarVisibilidad = () => {
  // Simplemente mandamos a redibujar el GeoJSON
  actualizarMapaGeoJSON();
};

const todosVisibles = (lista: any[]) =>
  lista.length > 0 && lista.every((e) => e.visible);

const alternarGrupo = (lista: any[], valor: boolean | null) => {
  const estado = valor === true;
  lista.forEach((equipo) => {
    equipo.visible = estado;
  });
  // Redibujamos una sola vez después de actualizar todos
  actualizarMapaGeoJSON();
};

// ==========================================
// AGRUPADOR MAESTRO CORREGIDO
// Nivel 1: Subtipo (Acceso, Distribución...) -> Nivel 2: Tipo (Camión, Trailer...)
// ==========================================
const jerarquiaEquipos = computed(() => {
  const mapa = new Map<string, Map<string, any[]>>();

  listaEquipos.value.forEach((equipo) => {
    // 1. El nivel superior ahora es el SUBTIPO (Acceso, Cliente, Distribución)
    const principal = equipo.subtipo || "Sin Categoría";

    // 2. El nivel interno ahora es el TIPO (Camión, Solar Trailer, Pila de agua)
    const secundario = equipo.tipo || "General";

    if (!mapa.has(principal)) mapa.set(principal, new Map());
    const subMapa = mapa.get(principal)!;

    if (!subMapa.has(secundario)) subMapa.set(secundario, []);
    subMapa.get(secundario)!.push(equipo);
  });

  // Transformamos los mapas a arreglos para el HTML
  return Array.from(mapa.entries()).map(([nombrePrincipal, subMapa]) => {
    const subgrupos = Array.from(subMapa.entries()).map(
      ([nombreSecundario, equipos]) => ({
        nombre: nombreSecundario,
        equipos: equipos,
      }),
    );

    // Sumamos todos los equipos de este subtipo (ej. Todos los de "Acceso") para el check general
    const equiposTotales = subgrupos.flatMap((sg) => sg.equipos);

    return {
      nombre: nombrePrincipal, // Ej: "Acceso"
      equiposTotales, // Lista plana de todos los equipos de Acceso
      subgrupos, // Ej: [{ nombre: "Camión", equipos: [...] }, { nombre: "Solar Trailer", equipos: [...] }]
    };
  });
});

/**
 * Obtener las posiciones de los equipos Rajant
 */
async function getRajantPositions() {
  await getALLRajantGPS();

  const estadoPrevio = new Map(
    listaEquipos.value.map((e: any) => [e.name, e.visible]),
  );
  const nuevaLista: any[] = [];

  allRajantArray.value.forEach((equipo: any) => {
    if (equipo.name === "" || equipo.latitud === 0 || equipo.longitud === 0)
      return; // Si no tiene datos GPS o nombre, lo saltamos

    const name = equipo.name;

    // Determinamos si debe estar visible (si es nuevo, true por defecto)
    const isVisible = estadoPrevio.has(name) ? estadoPrevio.get(name) : true;

    // Solo guardamos la data pura
    nuevaLista.push({
      ...equipo, // Guardamos todas las propiedades originales (lat, lng, tx, rx, etc)
      visible: isVisible,
    });
  });

  // Actualizamos la lista reactiva para que Vue dibuje los checkboxes
  listaEquipos.value = nuevaLista;

  // ==========================================
  // CONFIGURACIÓN DE LA CAPA (SYMBOL LAYER)
  // ==========================================
  const mapaInstancia = map.value || map;

  if (!mapaInstancia) {
    return;
  }

  crearFuenteYCapa(mapaInstancia);

  function crearFuenteYCapa(mapaInstancia: any) {
    if (!mapaInstancia.getSource("equipos-source")) {
      mapaInstancia.addSource("equipos-source", {
        type: "geojson",
        data: { type: "FeatureCollection", features: [] },
      });

      mapaInstancia.addLayer({
        id: "equipos-layer",
        type: "symbol",
        source: "equipos-source",
        layout: {
          "icon-image": 
          [
            "match",
            ["get", "subtipo"],
            "Cliente", "icono-camion",
            "Acceso",  "icono-rajant",
            "icono-camion" // Valor por defecto
          ],
          "icon-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            5,
            0.1,
            7,
            0.2,
            10,
            0.3, // A zoom 10 (lejos), el tamaño es 0.4
            15,
            0.7, // A zoom 15 (medio), el tamaño es 0.8
            20,
            1.2, // A zoom 20 (muy cerca), el tamaño es 1.5
          ],

          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            5,
            2, // A zoom 5 (muy lejos), letra tamaño 5
            10,
            6, // A zoom 10, letra tamaño 10
            15,
            10, // A zoom 15, letra tamaño 13
            17,
            14, // A zoom 17, letra tamaño 14
            20,
            16, // A zoom 20, letra tamaño 17
          ],

          "icon-allow-overlap": true, // "FALSE" Si chocan 2 iconos, oculta uno
          "text-allow-overlap": true, // "FALSE" Si chocan 2 textos, oculta uno

          "text-field": ["concat", ["get", "name"]],
          "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],

          "text-offset": [0, 1.7], // Mueve el texto debajo del icono
          "text-anchor": "top",
        },
        paint: {
          // Como no podemos usar fondos HTML, usamos un "Halo" (borde)
          // para que el texto blanco resalte sobre el mapa satelital
          "text-color": "#000000",
          // "text-color": "#000000",
          "text-halo-color": "#66BB6A",
          "text-halo-width": 2.5,
        },
      });
    }

    // 4. Inyectamos los datos iniciales
    actualizarMapaGeoJSON();
  }
}

/**
 * Lista de los Equipos Rajant con toda su información (Ancho de Banda y GPS)
 */
const allRajantArray = ref<any>([]);

/**
 * Obtener todas las coordenadas GPS de los equipos Rajant
 */
async function getALLRajantGPS() {
  const allData = await getRajantGPS();

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    allRajantArray.value = allData.data;
  }
}

let map: any = "";
const centerMap = ref<LngLatLike>([
  CONSTMAPS.longitud.value,
  CONSTMAPS.latitud.value,
]);

onMounted(async () => {
  getAllHaulTrucks();

  map = new maplibregl.Map({
    container: "map",
    center: centerMap.value,
    zoom: 14,
    pitch: 40,
    bearing: 30,
    antialias: true,
    style:
      "https://api.maptiler.com/maps/satellite/style.json?key=6JWVt6LFaY22nquimZpF",
  });

  map.addControl(new maplibregl.NavigationControl(), "top-right");
  map.addControl(new maplibregl.FullscreenControl(), "top-right");

  const img = new Image(45, 45);

  img.onload = () => {
    map.addImage("icono-rajant", img);
  };

  img.src = miIconoPersonalizado;

  const imgCamion = new Image(45, 45);

  imgCamion.onload = () => {
    map.addImage("icono-camion", imgCamion);
  };

  imgCamion.src = miIconoCamion;

  setTimeout(async () => {
    await getAllRajantPositions();
    await getRajantPositions();
  }, 500);
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    class: "defaultCard",
    color: "bgtopology"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(title.value), 1),
      _createVNode(_component_v_row, { class: "ma-0 mt-8" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_sheet, {
            color: "transparent",
            style: _normalizeStyle(_unref(mdAndDown) ? 'width: 100%' : `width: calc(100% - ${width.value}px)`)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_v_menu, {
                    "close-on-content-click": false,
                    location: "bottom start"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({ color: "#84D98E" }, props, {
                        "prepend-icon": "mdi-truck",
                        elevation: "2"
                      }), null, 16)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        "min-width": "300",
                        "max-height": "500",
                        class: "overflow-y-auto mt-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, { density: "compact" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_subheader, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Grupos de Equipos")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item, null, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_checkbox_btn, {
                                    "model-value": todosVisibles(listaEquipos.value),
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (
                          alternarGrupo(listaEquipos.value, $event)
                        )),
                                    color: "primary"
                                  }, null, 8, ["model-value"])
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { class: "font-weight-bold text-white" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" MOSTRAR TODOS ")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_divider),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jerarquiaEquipos.value, (grupo) => {
                                return (_openBlock(), _createBlock(_component_v_list_group, {
                                  key: grupo.nombre,
                                  value: grupo.nombre
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_list_item, _mergeProps(props, {
                                      "prepend-icon": "mdi-transit-connection-variant",
                                      title: grupo.nombre
                                    }), {
                                      append: _withCtx(() => [
                                        _createElementVNode("div", {
                                          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                                        }, [
                                          _createVNode(_component_v_checkbox_btn, {
                                            "model-value": todosVisibles(grupo.equiposTotales),
                                            "onUpdate:modelValue": ($event: any) => (
                                alternarGrupo(grupo.equiposTotales, $event)
                              ),
                                            color: "success"
                                          }, null, 8, ["model-value", "onUpdate:modelValue"])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1040, ["title"])
                                  ]),
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grupo.subgrupos, (subgrupo) => {
                                      return (_openBlock(), _createBlock(_component_v_list_group, {
                                        key: subgrupo.nombre,
                                        value: grupo.nombre + '-' + subgrupo.nombre
                                      }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_list_item, _mergeProps(props, {
                                            "prepend-icon": "mdi-folder-outline",
                                            title: subgrupo.nombre,
                                            class: "pl-4"
                                          }), {
                                            append: _withCtx(() => [
                                              _createElementVNode("div", {
                                                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                                              }, [
                                                _createVNode(_component_v_checkbox_btn, {
                                                  "model-value": todosVisibles(subgrupo.equipos),
                                                  "onUpdate:modelValue": ($event: any) => (
                                  alternarGrupo(subgrupo.equipos, $event)
                                ),
                                                  color: "info"
                                                }, null, 8, ["model-value", "onUpdate:modelValue"])
                                              ])
                                            ]),
                                            _: 2
                                          }, 1040, ["title"])
                                        ]),
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subgrupo.equipos, (equipo) => {
                                            return (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: equipo.name,
                                              class: "pl-12"
                                            }, {
                                              prepend: _withCtx(() => [
                                                _createVNode(_component_v_checkbox_btn, {
                                                  modelValue: equipo.visible,
                                                  "onUpdate:modelValue": ($event: any) => ((equipo.visible) = $event),
                                                  onChange: _cache[3] || (_cache[3] = ($event: any) => (alternarVisibilidad())),
                                                  color: "grey-darken-2"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(equipo.name), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_4
              ])
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_v_sheet, {
            color: "transparent",
            class: "pa-4 pr-0",
            width: width.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { class: "ma-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pa-0"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _createVNode(_component_v_select, {
                        modelValue: haulTrucksSelected.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((haulTrucksSelected).value = $event)),
                        items: computedListTruck.value,
                        disabled: computedListTruck.value.length == 0 || disabledAXIOS.value,
                        "item-title": "title",
                        "item-value": "value",
                        density: "compact",
                        variant: "outlined",
                        multiple: "",
                        "hide-details": "",
                        "virtual-scroll": ""
                      }, null, 8, ["modelValue", "items", "disabled"]),
                      _createElementVNode("h5", _hoisted_6, _toDisplayString(_unref(t)("datePickers.dateini")), 1),
                      _createVNode(_component_VueDatePicker, {
                        dark: "",
                        class: "mb-4",
                        modelValue: dateini.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dateini).value = $event)),
                        "model-type": _unref(STRING_GENERAL).time,
                        format: _unref(STRING_GENERAL).time,
                        "max-date": dateMAX.value
                      }, null, 8, ["modelValue", "model-type", "format", "max-date"]),
                      _createVNode(_component_v_btn, {
                        class: "mt-4",
                        color: "success",
                        disabled: (haulTrucksSelected.value.length === 0 || disabledAXIOS.value) || dateini.value === undefined || dateini.value === null || dateini.value === '',
                        block: "",
                        onClick: getHaulTruckPositions
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)("buttons.searchTruck")), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (showError.value)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    class: "ma-0 mt-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { class: "pa-0" }, {
                        default: _withCtx(() => [
                          _createTextVNode("No hay informacion")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (showCheckBoxes.value)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 1,
                    class: "ma-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        class: "pa-0",
                        cols: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filters.value.LATENCIA, (filter) => {
                                return (_openBlock(), _createBlock(_component_v_col, {
                                  key: filter.value,
                                  cols: "12",
                                  sm: "6",
                                  md: "3"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_checkbox, {
                                      modelValue: filter.active,
                                      "onUpdate:modelValue": ($event: any) => ((filter.active) = $event),
                                      label: filter.label,
                                      color: filter.color,
                                      density: "compact",
                                      "hide-details": "",
                                      onChange: onFilterChange
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "color"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        class: "pa-0",
                        cols: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            color: "red",
                            block: "",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (generarKMZ()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Generar KMZ ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["width"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})